import Partner from './Partner'
import WithPartner from 'containers/WithPartner'

export default WithPartner(Partner)
